<template>
  <div class="v-input va-input theme--light">
    <div class="v-input__control">
      <div class="v-input__slot">
        <label
          v-if="!hideLabel"
          :for="label + '-state'"
          class="v-label theme--light"
          style="left: 0; right: auto; position: relative"
        >
          {{ label }}
        </label>
        <div>
          <span :id="label + '-state'" :class="['v-chip', 'theme--light', 'v-size--default', color]">
            <span class="v-chip__content">{{ value }}</span>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'orange',
    },
  },
};
</script>
